export default __webpack_public_path__ + "static/media/logo.abd51c0d.jpg";